import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HeaderLoggedUser from './partials/HeaderLoggedUser';
import { getCookie } from './utils/cookies';
import AgencyDetails, { AgencyError, AgencyLoading } from './agency/AgencyDetails';
import LegalAcceptanceReceipt from './LegalAcceptanceReceipt';

const API_AUTH_URL = process.env.REACT_APP_AUTH_API_URL;

export default function Profile() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [attempt, setAttempt] = useState(0);
    const navigate = useNavigate();
    const token = getCookie('MMAUTH');

    useEffect(() => {
        const controller = new AbortController();
        const fetchData = async () => {
            setLoading(true);
            setError(false);
            setData(null);
            try {
                const response = await fetch(`${API_AUTH_URL}/auth/getLoggedFuneralHonorData`, {
                    headers: { 'Content-Type': 'application/json', 'MmTkn': token },
                    signal: controller.signal,
                    cache: 'no-store',
                });
                if (controller.signal.aborted) return;
                if (response.status === 401 || response.status === 403) {
                    navigate('/login', { replace: true });
                } else if (response.ok) {
                    const result = await response.json();
                    if (controller.signal.aborted) return;
                    if (result) setData(result);
                    else setError(true);
                } else setError(true);
            } catch {
                if (!controller.signal.aborted) setError(true);
            } finally {
                if (!controller.signal.aborted) setLoading(false);
            }
        };
        fetchData();
        return () => controller.abort();
    }, [navigate, token, attempt]);

    return <div className="ef-page ef-agency-page">
        <HeaderLoggedUser />
        <div className="ef-agency-container py-4"><Link className="ef-agency-button bg-primary" to="/preventivi">Richieste di preventivo →</Link></div>
        <div className="ef-agency-owner-bar"><div className="ef-agency-container"><div><p className="ef-agency-eyebrow">Il tuo profilo · Anteprima</p><p>La tua agenzia, come la vedono le famiglie.</p></div><Link to="/modifica-profilo" className="ef-agency-button bg-primary">Modifica profilo <span aria-hidden="true">↗</span></Link></div></div>
        {loading ? <AgencyLoading /> : error || !data ? <AgencyError onRetry={() => setAttempt(value => value + 1)} /> : <AgencyDetails data={data} agencyId={data.publicId} source="profile" />}
        {!loading && !error && data && <LegalAcceptanceReceipt receipt={data.legalAcceptance} />}
    </div>;
}
